module.exports = __webpack_public_path__ + "static/media/frames-11.ed1f4420.jpg";